export interface Project {
  id: number;
  title: string;
  category: string;
  year: string;
  description: string;
  image: string;
  images: string[];
  icon: string;
}

const STORAGE_KEY = 'architecture_projects';

// Varsayılan projeler
const defaultProjects: Project[] = [
  {
    id: 1,
    title: "Çağdaş Minimalist Villa - Betonarme & Ahşap Detay",
    category: "Konut",
    year: "2024",
    icon: "🏡",
    description: "Modern mimari çizgiler ve doğal malzemelerin mükemmel uyumu. İki katlı villa tasarımında betonarme strüktür üzerine ahşap kaplama detayları, geniş cam yüzeyler ve konsol çıkmalar kullanılmıştır. Açık hava oturma alanı, şömine ve dekoratif aydınlatma ile sosyal yaşam alanları zenginleştirilmiştir. Geniş teraslar, yeşil çatı uygulaması ve peyzaj düzenlemesi ile sürdürülebilir mimari yaklaşımı benimsenmiştir. Proje, minimalist tasarım anlayışı ile konfor ve estetiği bir araya getirmektedir.",
    image: "/projects/yapi1/2_1_Photo.jpg",
    images: [
      "/projects/yapi1/2_1_Photo.jpg",
      "/projects/yapi1/2_2_Foto.jpg",
      "/projects/yapi1/2_3_Foto.jpg",
      "/projects/yapi1/2_4_Foto.jpg",
      "/projects/yapi1/2_5_Foto.jpg",
      "/projects/yapi1/2_6_Foto.jpg",
      "/projects/yapi1/2_7_Foto.jpg",
      "/projects/yapi1/2_8_Foto.jpg",
      "/projects/yapi1/2_9_Foto.jpg",
      "/projects/yapi1/2_10_Foto.jpg"
    ]
  },
  {
    id: 2,
    title: "Lüks Villa Kompleksi - Havuz & Peyzaj Tasarımı",
    category: "Konut",
    year: "2024",
    icon: "🏊",
    description: "Doğayla bütünleşen, havuzlu lüks villa kompleksi projesi. Modern ve geleneksel mimari unsurların sentezi ile tasarlanmıştır. Merkezi yüzme havuzu etrafında organize edilmiş yaşam alanları, ahşap pergola sistemleri, dikey ahşap şeritler ile gölgeleme elemanları ve geniş teraslar projenin öne çıkan özellikleridir. Açık ve kapalı yaşam alanlarının akıcı geçişleri, peyzaj düzenlemesi ve sosyal alanlar ile aile yaşamına uygun bir tatil köyü atmosferi yaratılmıştır. Vaziyet planı ile arazi kullanımı optimize edilmiştir.",
    image: "/projects/yapi2/selenayy2_1Photo.jpg",
    images: [
      "/projects/yapi2/selenayy2_1Photo.jpg",
      "/projects/yapi2/selenayy2_2Foto.jpg",
      "/projects/yapi2/selenayy2_3Foto.jpg",
      "/projects/yapi2/selenayy2_4Foto.jpg",
      "/projects/yapi2/selenayy2_5Foto.jpg",
      "/projects/yapi2/selenayy2_6Foto.jpg",
      "/projects/yapi2/selenayy2_7Foto.jpg",
      "/projects/yapi2/selenayy2_8Foto.jpg",
      "/projects/yapi2/selenayy2_9Foto.jpg",
      "/projects/yapi2/selenayy2_10Foto.jpg",
      "/projects/yapi2/27111vaziyet.jpg"
    ]
  },
  {
    id: 3,
    title: "Mimari Bitirme Projesi - Kapsamlı Tasarım Çalışması",
    category: "3D Modelleme",
    year: "2023",
    icon: "🎨",
    description: "Üniversite bitirme projesi olarak hazırlanan kapsamlı mimari tasarım çalışması. Proje, konsept geliştirmeden teknik detaylara kadar tüm mimari tasarım süreçlerini içermektedir. Vaziyet planı, kat planları, kesitler, cepheler ve 3D görselleştirmeler ile desteklenmiş profesyonel bir portfolyo çalışmasıdır. Modern mimari anlayış ve fonksiyonel çözümler bir araya getirilmiştir.",
    image: "/projects/proje1/proje1.jpg",
    images: ["/projects/proje1/proje1.jpg"]
  },
  {
    id: 4,
    title: "Konut Projesi - Kat Planları & Teknik Çizimler",
    category: "Konut",
    year: "2023",
    icon: "🏠",
    description: "Detaylı kat planları, kesit paftaları ve vaziyet planı ile hazırlanmış konut projesi. Zemin kat ve üst katlar için ayrıntılı teknik çizimler, oda düzenlemeleri ve çevre düzenlemesi planları içermektedir. Proje, 1/200 ve 1/100 ölçeklerinde hazırlanmış profesyonel mimari paftalardan oluşmaktadır. Fonksiyonel mekan organizasyonu ve ergonomik tasarım prensipleri göz önünde bulundurulmuştur.",
    image: "/projects/proje2/proje2_1.jpg",
    images: [
      "/projects/proje2/proje2_1.jpg",
      "/projects/proje2/proje2_2.jpg",
      "/projects/proje2/proje2_3.jpg",
      "/projects/proje2/proje2_4.jpg",
      "/projects/proje2/proje2_5.jpg",
      "/projects/proje2/proje2_6.jpg",
      "/projects/proje2/proje2_7.jpg"
    ]
  },
  {
    id: 5,
    title: "Kapsamlı Mimari Proje Portfolyosu - 5 Pafta",
    category: "3D Modelleme",
    year: "2023",
    icon: "📐",
    description: "Çoklu pafta içeren geniş kapsamlı mimari proje çalışması. 5 farklı paftada sunulan bu proje, vaziyet planından detay çizimlerine, perspektif görünümlerden teknik kesitlere kadar tüm mimari sunum tekniklerini içermektedir. Her pafta, projenin farklı bir yönünü profesyonel standartlarda sunmaktadır. Kapsamlı bir mimari tasarım sürecinin tüm aşamalarını yansıtan portfolyo çalışmasıdır.",
    image: "/projects/proje3/proje3_1.jpg",
    images: [
      "/projects/proje3/proje3_1.jpg",
      "/projects/proje3/proje3_2.jpg",
      "/projects/proje3/proje3_3.jpg",
      "/projects/proje3/proje3_4.jpg",
      "/projects/proje3/proje3_5.jpg"
    ]
  },
  {
    id: 6,
    title: "Mimari Sunum Paftası - Teknik Dokümantasyon",
    category: "Restorasyon",
    year: "2023",
    icon: "🏛️",
    description: "Profesyonel mimari sunum paftası çalışması. Teknik çizimler, 3D görseller ve detay çözümlerinin bir araya getirildiği kapsamlı bir sunum. Proje, mimari tasarım sürecinin tüm aşamalarını profesyonel bir şekilde belgeleyen teknik dokümantasyon örneğidir. Plan, kesit, görünüş ve perspektif çizimleri ile desteklenmiştir.",
    image: "/projects/proje4/proje4.jpg",
    images: ["/projects/proje4/proje4.jpg"]
  },
  {
    id: 7,
    title: "İç Mekan Tasarım Projesi - Render & Teknik Pafta",
    category: "Ticari",
    year: "2023",
    icon: "🏢",
    description: "Detaylı iç mekan tasarım projesi. Fotorealistik render görselleri ve teknik teslim paftaları ile sunulmuştur. Proje, mekan organizasyonu, malzeme seçimi, renk paleti ve aydınlatma tasarımı gibi iç mimarlık disiplininin tüm unsurlarını içermektedir. Modern ve fonksiyonel bir iç mekan tasarımı örneğidir. Render paftası ve teknik teslim paftası ile profesyonel sunum standartlarında hazırlanmıştır.",
    image: "/projects/icmekan/icmekan_1.jpg",
    images: [
      "/projects/icmekan/icmekan_1.jpg",
      "/projects/icmekan/icmekan_2.jpg"
    ]
  }
];

export const getProjects = (): Project[] => {
  try {
    // Varsayılan projeleri her zaman yükle (yeni projeler için)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultProjects));
    return defaultProjects;
  } catch (error) {
    console.error('Error loading projects:', error);
    return defaultProjects;
  }
};

export const saveProjects = (projects: Project[]): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
  } catch (error) {
    console.error('Error saving projects:', error);
  }
};

export const addProject = (project: Omit<Project, 'id'>): Project => {
  const projects = getProjects();
  const newProject: Project = {
    ...project,
    id: Date.now()
  };
  projects.push(newProject);
  saveProjects(projects);
  return newProject;
};

export const deleteProject = (id: number): void => {
  const projects = getProjects();
  const filtered = projects.filter(p => p.id !== id);
  saveProjects(filtered);
};

export const updateProject = (id: number, updates: Partial<Project>): void => {
  const projects = getProjects();
  const index = projects.findIndex(p => p.id === id);
  if (index !== -1) {
    projects[index] = { ...projects[index], ...updates };
    saveProjects(projects);
  }
};

export const resetToDefaultProjects = (): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultProjects));
};

export const getDefaultProjects = (): Project[] => {
  return defaultProjects;
};
